import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import Accueil from "../services/Accueil";
import Loader from "./Loader";
import Image from "./images";

const Partenaire = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [partenaires, setPartenaires] = useState([]);
  const [loading, setLoading] = useState(true);
  const sliderRef = React.useRef(null);
  const AccueilServices = new Accueil();

  useEffect(() => {
    const fetchPartenaires = async () => {
      try {
        const data = await AccueilServices.getPartenaires();
        setPartenaires(data || []);
      } catch (error) {
        console.error("Erreur lors de la récupération des partenaires :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPartenaires();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getSlidesToShow = (maxVisible) => {
    if (isMobile) {
      return 1;
    }
    return Math.min(Math.max(1, partenaires.length), maxVisible);
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: getSlidesToShow(5),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: getSlidesToShow(4),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <div className="m-5">
        <Loader height={100} width={100} />
      </div>
    );
  }

  if (!partenaires.length) {
    return null;
  }

  return (
    <div className="container-fluid partenaire py-4">
      <div className="row">
        <div className="col-12 text-center mb-4">
          <h1 className="partenaire-title">
            Nous leur apportons <span className="green">du BONHEUR</span>
          </h1>
        </div>
      </div>

      <div className="row justify-content-center px-5 ms-2 partenaire-body">
        <div className="col-12 px-0 partenaire-slider">
          <Slider {...sliderSettings} ref={sliderRef}>
            {partenaires.map((partenaire, index) => (
              <div key={partenaire.id ?? index} className="partenaire-slide">
                <a
                  href={partenaire.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="d-flex justify-content-center align-items-center w-100"
                >
                  <Image
                    image={partenaire.logo}
                    alt={partenaire.nom}
                    className="img-fluid partenaire-logo"
                  />
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Partenaire;
